export default "__VITE_ASSET__eW12gLz3__"